var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBonusesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8 28.8406C1.8 29.4819 2.33625 30 3 30H13.725V16.3768H1.8V28.8406ZM16.275 30H27C27.6638 30 28.2 29.4819 28.2 28.8406V16.3768H16.275V30ZM28.8 7.68116H23.265C23.775 6.9058 24.075 5.98551 24.075 5C24.075 2.24275 21.7538 0 18.9 0C17.3475 0 15.9488 0.666666 15 1.71739C14.0513 0.666666 12.6525 0 11.1 0C8.24625 0 5.925 2.24275 5.925 5C5.925 5.98551 6.22125 6.9058 6.735 7.68116H1.2C0.53625 7.68116 0 8.19928 0 8.84058V13.913H13.725V7.68116H16.275V13.913H30V8.84058C30 8.19928 29.4638 7.68116 28.8 7.68116ZM13.725 7.53623H11.1C9.6525 7.53623 8.475 6.39855 8.475 5C8.475 3.60145 9.6525 2.46377 11.1 2.46377C12.5475 2.46377 13.725 3.60145 13.725 5V7.53623ZM18.9 7.53623H16.275V5C16.275 3.60145 17.4525 2.46377 18.9 2.46377C20.3475 2.46377 21.525 3.60145 21.525 5C21.525 6.39855 20.3475 7.53623 18.9 7.53623Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusesIcon);
export default __webpack_public_path__ + "static/media/bonusesIcon.12ed2e83ab0af142666bde8d18770cbc.svg";
export { ForwardRef as ReactComponent };